import React from "react";
import { raceCourseData } from "../../data/data";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import eventImg from "../../assets/about.jpg";
import headerIcon from "../../assets/data1/image 4.png";


const RaceCourseContent = ({ racecourse, viewMode }) => {
  const cookiedata = Cookies.get("i18next");
  const { t } = useTranslation();

  const content = cookiedata === "en" ? raceCourseData[racecourse]?.content || "" : raceCourseData[racecourse]?.contentAr;
  const content1 = cookiedata === "en" ? raceCourseData[racecourse]?.content1 || "" : raceCourseData[racecourse]?.content1Ar;

  const formattedContent = content?.replace(/\n/g, "<br/>");
  const formattedContent1 = content1?.replace(/\n/g, "<br/>");

  if (viewMode === "about") {
    return (
      <>
        <div className="new-about-header">
          <h3> {cookiedata === "en" ? raceCourseData[racecourse]?.heading : raceCourseData[racecourse]?.headingAr}</h3>
          <img src={headerIcon} alt="icon" style={{width: '45px', opacity: 0.3,margin: '0px 0px 0px 10px'}} />
        </div>
        <div className="new-about-body">
          <img src={raceCourseData[racecourse]?.image} alt="Map" className="new-map-img" />
          <p className="new-about-desc" dangerouslySetInnerHTML={{ __html: formattedContent }}></p>
        </div>
      </>
    );
  }

  if (viewMode === "overview") {
    return (
      <>
        <div className="new-overview-text">
          <h3>{cookiedata === "en" ? raceCourseData[racecourse]?.heading : raceCourseData[racecourse]?.headingAr}</h3>
          <p dangerouslySetInnerHTML={{ __html: formattedContent1 }}></p>
        </div>
        <div className="new-overview-image">
         <img src={eventImg} alt="Rider"/>
        </div>
      </>
    );
  }

  return null;
};

export default RaceCourseContent;